<template>
  <div>
    <b-card header="Transferencias"
        :key="key"
        class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showTransferencias= !showTransferencias">
        <i :class="showTransferencias ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-btn class="card-header-add" 
          v-if="showTransferencias"
          variant="primary" 
          size="sm"
          @click.prevent="agregarTransferencia">
        <i class="fa fa-plus"></i>
      </b-btn>
      <b-collapse class="mt-2" v-model="showTransferencias">
        <b-table 
            class="registro transferencias" 
            responsive="sm" 
            :items="transferenciasItems" 
            :fields="fields"
            @row-clicked="consultar">
          <template v-slot:cell(fechaAutorizacion)="data">
            {{ data.item.fechaAutorizacion | fecha }}
          </template>
          <template v-slot:cell(fechaTransferencia)="data">
            {{ data.item.fechaTransferencia | fecha }}
          </template>
          <template v-slot:cell(importe)="data">
            {{ data.item.importe | moneda }}
          </template>
          <template v-slot:cell(opciones)="data">
            <b-dropdown v-if="borrarHabilitado" 
                variant="link" 
                toggle-class="text-decoration-none" no-caret>
              <template slot="button-content">
                <i class="fa fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item
                  v-if="data.item.rechazada"
                  @click.stop="agregarRetransferencia(data.item)">
                <i class="fa fa-repeat"></i>Retransferir</b-dropdown-item>
              <b-dropdown-item @click.stop="borrarTransferencia(data.item)">
                <i class="fa fa-close"></i>Borrar Autorizacion</b-dropdown-item>
            </b-dropdown>
          </template>            

          <template v-slot:cell(detailShowing)="row">
            <b-btn class="detailShowing" 
                size="sm" 
                v-if="row.item.observaciones != ''" 
                @click.stop="row.toggleDetails">
              {{ ( row.detailShowing) ? '-' : '+' }}
            </b-btn>            
          </template>

          <template slot="row-details" slot-scope="row">
            <b-row>
              <b-col cols="12">
                <p class="descripcion">{{ row.item.observaciones }}</p>
              </b-col>
            </b-row>
          </template>
        </b-table>
      </b-collapse>
    </b-card>

    <b-modal ref="transferenciaModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM">
      <app-transferencia
        :eventoId="eventoId"
        :participanteId="participanteId"
        :eventoEtapaId="eventoEtapaId"
        :transferenciaId="transferenciaId"
        :transferenciaImporte="transferenciaImporte"
        @close="closeTransferencia">
      </app-transferencia>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Transferencia from  '../transferencias/ABM.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'participanteDatos/getField',
  mutationType: 'participanteDatos/updateField',
});

export default {
  name: 'ParticipanteDatosTransferencias',
  components: {
    appTransferencia: Transferencia,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  props: {
    eventoEtapaId: {
      type: Number,
      default: 0
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        { key: 'fechaAutorizacion' },
        { key: 'fechaTransferencia' },
        { key: 'estado'},        
        // {
        //   key: 'completada',
        //   class: 'text-center'
        // },
        { key: 'importe' },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      transferenciaId: 0,
      transferenciaImporte: 0,

      showTransferencias: true,
      borrarHabilitado: false,

      labelCols: 2,
      key: 100,
    }
  },
  computed: {
    ...mapFields([
      'eventoId',
      'participanteId',

      'transferencias',
    ]),
    transferenciasItems() {
      if (this.transferencias) {
        if (this.transferencias.length != 0) {
          if (this.eventoEtapaId != 0) {
            return this.transferencias.filter(t => t.eventoEtapaId == this.eventoEtapaId);
          } else {
            return this.transferencias;
          }
        }
      }
      return null;
    },

  },
  created() {
    if ((/true/i).test(this.$store.getters['user/admin'])) {
      this.borrarHabilitado = true;
    }
  },  
  methods: {
    refresh() {
      this.key++;
    },
    agregarTransferencia() {
      this.transferenciaId = 0;
      this.transferenciaImporte = 0;
      this.$refs.transferenciaModal.show();
    }, 
    agregarRetransferencia(item) {
      this.transferenciaId = item.id;
      this.transferenciaImporte = item.importe;
      this.$refs.transferenciaModal.show();
    }, 
    closeTransferencia(saved) {
      this.$refs.transferenciaModal.hide();
      if (saved) {
        this.$store.dispatch('participanteDatos/getTransferencias')
          .catch( error => this.showErrorMsj (error));
      }
    },
    borrarTransferencia(item) {
      this.showModalConfirm('¿Desea borrar la autorización seleccionada?', 
            this.borrarTransferenciaSeleccionada.bind(this, item.id), 'Si', null, 'No')
    },
    borrarTransferenciaSeleccionada(transferenciaId) {
      this.showSpinner();
      this.$store.dispatch('participanteDatos/deleteTransferencia', transferenciaId)
        .then(() => {
          this.showModalMsj('La autorización seleccionada se borró con éxito.', null, null, 'light')
          this.$store.dispatch('participanteDatos/getTransferencias');
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    consultar (item) {
      this.$router.push({ name: 'ParticipanteTransferenciaDatos', 
                          params: { 
                            eventoId: this.eventoId, 
                            participanteId: this.participanteId,
                            id: item.id 
                          }});
    },
  },
  watch: {
  }   
}
</script>

<style>
  .registro.transferencias table th {
    border-top: none;
  }
  .registro.transferencias table td {
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .registro.transferencias table td[aria-colindex="1"] {
    width: 40px;
  }
  .registro.transferencias table td[aria-colindex="1"] button {
    position: relative;
    top: -5px;
  }
  .registro.transferencias table td[aria-colindex="2"] {
    width: 15%;
  }
  .registro.transferencias table td[aria-colindex="3"] {
    width: 15%;
  }
  .registro.transferencias table td[aria-colindex="4"] {
    width: calc(50% - 100px);
  }
  .registro.transferencias table td[aria-colindex="5"] {
    width: 20%;
  }
  .registro.transferencias table td[aria-colindex="6"] {
    width: 60px;
  }

  .registro.transferencias table p.descripcion {
    margin-bottom: 5px;
    padding-left: 40px;
    width: calc(90% - 40px);
    white-space: pre-wrap;
  }
</style>